import { createAction } from '@reduxjs/toolkit';
import { storeName } from '../config';
import { OkrTeamOverviewFilters } from '../interfaces';

export const changeFilter = createAction<{
  key: keyof OkrTeamOverviewFilters;
  value: string | number | number[] | null;
}>(`${storeName}/changeFilter`);
